import { render, staticRenderFns } from "./brandModule.vue?vue&type=template&id=06ef2a90&scoped=true&"
import script from "./brandModule.vue?vue&type=script&lang=js&"
export * from "./brandModule.vue?vue&type=script&lang=js&"
import style0 from "./brandModule.vue?vue&type=style&index=0&id=06ef2a90&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ef2a90",
  null
  
)

export default component.exports